export const gray50 = '#ACB2B7';
export const depot = '#F96302';
